<template>
  <div class="container is-uppercase has-text-weight-bold">
    <Header/>
    <div class="section">
      <h1 class="is-size-5 has-text-weight-bold">{{ 'Points' | translate }}: {{ $store.getters.getTrainingDays }}</h1><br>
      <div class="columns is-mobile">
        <div class="column is-one-third">
          <span :class="'is-xlarge is-size-3 icon ' + ($store.getters.getTrainingDays >= 1 ? 'stamp-complete' : 'stamp-incomplete')">10</span><br/><br/>
          <span :class="'is-xlarge is-size-3 icon ' + ($store.getters.getTrainingDays >= 14 ? 'stamp-complete' : 'stamp-incomplete')">200</span>
        </div>
        <div class="column is-one-third">
          <span :class="'is-xlarge is-size-3 icon ' + ($store.getters.getTrainingDays >= 3 ? 'stamp-complete' : 'stamp-incomplete')">30</span><br/><br/>
          <span :class="'is-xlarge is-size-3 icon ' + ($store.getters.getTrainingDays >= 30 ? 'stamp-complete' : 'stamp-incomplete')">500</span>
        </div>
        <div class="column is-one-third">
          <span :class="'is-xlarge is-size-3 icon ' + ($store.getters.getTrainingDays >= 7 ? 'stamp-complete' : 'stamp-incomplete')">100</span><br/><br/>
          <span :class="'is-xlarge is-size-3 icon ' + ($store.getters.getTrainingDays >= 100 ? 'stamp-complete' : 'stamp-incomplete')">1000</span>
        </div>
      </div>
      <hr>
      <h1 class="is-size-5 has-text-weight-bold">{{ 'Record' | translate }}</h1>
      <h2 class="is-size-4 has-text-weight-bold has-text-primary">{{ $store.getters.getTrainingRecord }} min</h2>
      <hr>
      <h1 class="is-size-5 has-text-weight-bold">{{ 'Average' | translate }}</h1>
      <h2 class="is-size-4 has-text-weight-bold has-text-primary">{{ $store.getters.getTrainingAverage }} min</h2>
      <hr>
      <h1 class="is-size-5 has-text-weight-bold">{{ 'Complete training time' | translate }}</h1>
      <h2 class="is-size-4 has-text-weight-bold has-text-primary">{{ $store.getters.getTrainingHours }} min</h2>
    </div>
    <Footer style="position:fixed;left:0;right:0;bottom:0;"/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'Statisitc',
  data () {
    return {
      profile: this.$store.getters.getProfile
    }
  },
  methods: {
    updateProfile () {
      this.profile.age = parseInt(this.profile.age)
      this.profile.height = parseInt(this.profile.height)
      this.profile.weight = parseInt(this.profile.weight)
      this.$store.dispatch('updateProfile', this.profile)
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style>
.stamp-complete {
  background-image: url(/../../static/muscle_heroes_silhouette.svg);
}
.stamp-incomplete {
  background-image: url(/../../static/muscle_heroes_silhouette_grey.svg);
}
</style>




// WEBPACK FOOTER //
// src/components/Settings/Statisitc.vue